module.exports = __webpack_public_path__ + "static/media/PREVENCION_MATERIAL2.f327edad.png";